import React from 'react'

const IconImage = ({ color = 'currentColor' }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M23,1 L23,23 L1,23 L1,1 L23,1 Z M17,12.413 L10.9997759,18.410187 L7.999,15.41 L3,20.416 L3,21 L21,21 L21,16.41 L17,12.413 Z M21,3 L3,3 L3,17.586 L7.99960905,12.581593 L11,15.582 L16.9999552,9.58627929 L21,13.583 L21,3 Z M10,5 C11.6568542,5 13,6.34314575 13,8 C13,9.65685425 11.6568542,11 10,11 C8.34314575,11 7,9.65685425 7,8 C7,6.34314575 8.34314575,5 10,5 Z M10,7 C9.44771525,7 9,7.44771525 9,8 C9,8.55228475 9.44771525,9 10,9 C10.5522847,9 11,8.55228475 11,8 C11,7.44771525 10.5522847,7 10,7 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconImage
